import axios from 'axios';
import { BASE_API_URL } from './baseServices';
import { fetchWithAuth } from '../utils/api';

export const fetchRoleUsers = async (orgId, userId) => {
    try {
        const res = await fetchWithAuth(`ADMINRoutes/CWIGetDDLItems?OrgId=${orgId}&UserId=${userId}`, {
            method: 'GET',
        });
        const data = await res.json();
        return data.ResultData;
    } catch (error) {
        console.error('Error fetching role users:', error);
        throw error;
    }
};

export const fetchModuleScreens = async (moduleId) => {
    try {
        const res = await fetchWithAuth(`ADMINRoutes/MenuListBYModules?ModuleId=${moduleId}`, {
            method: 'GET',
        });const data = await res.json();
        return data.ResultData;
    } catch (error) {
        console.error('Error fetching module screens:', error);
        throw error;
    }
};